import React from 'react';
import MaterialTable from 'material-table';
import { t } from 'ttag';
import UnarchiveOutlinedIcon from '@material-ui/icons/UnarchiveOutlined';
import ArrowCircleRightRoundedIcon from '@material-ui/icons/SwapHoriz';
import { localization } from './utils';
import { USER_STATUS } from '../../utils/enums';

const DataTable = ({
  customRowStyle,
  isLoading,
  title,
  columns,
  data,
  onEdit,
  onClosed,
  onOpen,
  onStatement,
  onProtocol,
  onStatistics,
  onOpenStatement,
  onCloseStatement,
  onGeneratePdf,
  onGenerateXls,
  onCloseProtocol,
  onGenerateRowPdf,
  onArvitate,
  onArvitateTrainer,
  onActivateTrainer,
  onActivate,
  onRank,
  onAdd,
  onDelete,
  onChangeGroup,
  onDeleteCer,
  unDeleteCer,
  toolbar,
  pageSize,
  onViewAthlete,
  customActions,
  filtering,
  isEditable,
  onView,
  selection,
  onSelectionChange,
  selectionProps,
  components,
  showTextRowsSelected,
  tableRef,
  search,
  processLoading,
  isDeletableFn,
  isEditableFn,
}) => {
  const actions = [];
  if (onView && !isEditable) {
    actions.push({
      icon: 'visibility',
      tooltip: t`Переглянути`,
      onClick: (e, rowData) => onView(rowData),
    });
  }
  if (onViewAthlete) {
    actions.push({
      icon: 'visibility',
      tooltip: t`Переглянути спортсменів`,
      onClick: (event, rowData) => onViewAthlete(event, rowData),
    });
  }
  if (onGeneratePdf) {
    actions.push({
      icon: 'picture_as_pdf',
      tooltip: t`Make PDF`,
      isFreeAction: true,
      disabled: processLoading,
      onClick: (event, rowData) => onGeneratePdf(event, rowData),
    });
  }
  if (onGenerateXls) {
    actions.push({
      icon: 'file_download',
      tooltip: t`Завантажити список спортсменів`,
      isFreeAction: true,
      disabled: processLoading,
      onClick: (event, rowData) => onGenerateXls(event, rowData),
    });
  }
  if (onStatistics) {
    actions.push({
      icon: 'pie_chart',
      tooltip: t`Статистика Екзамену`,
      isFreeAction: true,
      onClick: (event, rowData) => onStatistics(event, rowData),
    });
  }
  if (onOpenStatement) {
    actions.push((rowData) => ({
      icon: 'lock_open',
      tooltip: t`Відкрити відомість`,
      onClick: (event, rowData) => onOpenStatement(event, rowData),
      hidden: rowData.statusStatement === '1',
    }));
  }
  if (onCloseStatement) {
    actions.push((rowData) => ({
      icon: 'done',
      tooltip: t`Сформувати відомість`,
      onClick: (event, rowData) => onCloseStatement(event, rowData),
      hidden: rowData.statusStatement === '2',
    }));
  }
  if (onCloseProtocol) {
    actions.push({
      icon: 'check_icon',
      tooltip: t`Закрити протокол`,
      position: 'toolbar',
      isFreeAction: true,
      onClick: (event, rowData) => onCloseProtocol(event, rowData),
    });
  }
  if (onClosed) {
    actions.push({
      icon: 'check_icon',
      tooltip: t`Закрити реєстрацію`,
      isFreeAction: true,
      onClick: (event, rowData) => onClosed(event, rowData),
    });
  }
  if (onOpen) {
    actions.push({
      icon: 'lock_open',
      tooltip: t`Відкрити реєстрацію`,
      isFreeAction: true,
      onClick: (event, rowData) => onOpen(event, rowData),
    });
  }
  if (onGenerateRowPdf) {
    actions.push({
      icon: 'picture_as_pdf',
      tooltip: t`Згенерувати PDF`,
      disabled: processLoading,
      onClick: (event, rowData) => onGenerateRowPdf(event, rowData),
    });
  }
  if (onStatement) {
    actions.push({
      icon: 'assignment',
      tooltip: t`Відомості`,
      isFreeAction: true,
      onClick: (event, rowData) => onStatement(event, rowData),
    });
  }
  if (onProtocol) {
    actions.push({
      icon: 'assessment',
      tooltip: t`Протоколи`,
      isFreeAction: true,
      onClick: (event, rowData) => onProtocol(event, rowData),
    });
  }
  if (onArvitate) {
    actions.push((rowData) => ({
      icon: 'archive',
      tooltip: t`Архівувати`,
      onClick: (event, rowData) => onArvitate(event, rowData),
      hidden: rowData.athleteStatus !== USER_STATUS.active,
    }));
  }
  if (onArvitateTrainer) {
    actions.push((rowData) => ({
      icon: 'archive',
      tooltip: t`Архівувати`,
      onClick: (event, rowData) => onArvitateTrainer(event, rowData),
      hidden: rowData.trainerStatus !== USER_STATUS.active,
    }));
  }
  if (onActivateTrainer) {
    actions.push((rowData) => ({
      icon: 'verified_user',
      tooltip: t`Активувати`,
      onClick: (event, rowData) => onActivateTrainer(event, rowData),
      hidden: rowData.trainerStatus === USER_STATUS.active,
    }));
  }
  if (onActivate) {
    actions.push((rowData) => ({
      icon: 'verified_user',
      tooltip: t`Активувати`,
      onClick: (event, rowData) => onActivate(event, rowData),
      hidden: rowData.athleteStatus === USER_STATUS.active,
    }));
  }
  if (onRank) {
    actions.push({
      icon: 'visibility',
      tooltip: t`Переглянути`,
      onClick: (event, rowData) => onRank(event, rowData),
    });
  }
  if (onEdit && !isEditable) {
    actions.push((rowData) => ({
      icon: 'edit',
      tooltip: t`Редагувати`,
      disabled: isEditableFn && !isEditableFn(rowData),
      onClick: (event, d) => onEdit(event, d),
    }));
  }
  if (onDeleteCer) {
    actions.push((rowData) => ({
      icon: 'archive',
      tooltip: t`Архівувати екзамен`,
      onClick: (event, rowData) => onDeleteCer(event, rowData),
      hidden: rowData.status === '3',
    }));
  }
  if (unDeleteCer) {
    actions.push((rowData) => ({
      icon: () => <UnarchiveOutlinedIcon />,
      tooltip: t`Розархівувати екзамен`,
      onClick: (event, rowData) => unDeleteCer(event, rowData),
      hidden: rowData.status !== '3',
    }));
  }
  if (onAdd && !isEditable) {
    actions.push({
      icon: 'add',
      tooltip: t`Додати`,
      isFreeAction: true,
      onClick: (event) => onAdd(event),
    });
  }
  if (onChangeGroup) {
    actions.push({
      icon: () => <ArrowCircleRightRoundedIcon />,
      tooltip: t`Перевести спортсмена в іншу групу`,
      onClick: (event, rowData) => onChangeGroup(event, rowData),
    });
  }
  const editable_actions = {
    isDeletable: isDeletableFn,
    isEditable: () => false,
  };

  if (onDelete) {
    editable_actions.onRowDelete = (oldData) =>
      new Promise((resolve) => {
        onDelete(oldData);
        resolve();
      });
  }

  if (onAdd && isEditable) {
    editable_actions.onRowAdd = (newData) =>
      new Promise((resolve) => {
        onAdd(newData);
        resolve();
      });
  }

  if (onEdit && isEditable) {
    editable_actions.onRowUpdate = (newData) =>
      new Promise((resolve) => {
        onEdit(newData);
        resolve();
      });
  }

  if (customActions) {
    actions.push(...customActions);
  }

  const options = {
    search: search === undefined ? true : search,
    toolbar,
    pageSize,
    pageSizeOptions: [20, 50, 100],
    actionsColumnIndex: -1,
    filtering,
    selection,
    selectionProps,
    showTextRowsSelected,
  };

  if (customRowStyle) {
    options.rowStyle = customRowStyle;
  }
  return (
    <MaterialTable
      tableRef={tableRef}
      isLoading={isLoading}
      options={options}
      localization={localization}
      title={title}
      columns={columns}
      data={data}
      actions={actions}
      editable={editable_actions}
      onSelectionChange={onSelectionChange}
      components={components}
    />
  );
};

DataTable.defaultProps = {
  toolbar: true,
  pageSize: 20,
  filtering: false,
};

export default DataTable;
